// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"stem-splitter-category-item_wrapper__uMvRX","selected":"stem-splitter-category-item_selected__KjJ5x","text":"stem-splitter-category-item_text__ex6_c"};